/* import __COLOCATED_TEMPLATE__ from './finish-timing-association-table.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';

export default class FinishTimingAssociationTableComponent extends Component 
{
	@service store;
	@service ajax;

	@tracked enteredBib = null;
	
	get associateDisabled()
	{
		return this.args.selectedFinishImpulse == null || this.args.selectedFinishPlungerImpulse == null;
	}
	get disassociateDisabled()
	{
		return this.args.selectedBibRecord != null || this.args.selectedFinishImpulse != null || this.args.selectedFinishPlungerImpulse == null;
	}
	get promotePlungerImpulseDisabled()
	{
		return this.args.selectedFinishPlungerImpulse == null || this.args.selectedFinishImpulse != null || this.args.selectedBibRecord != null || this.args.selectedFinishPlungerImpulse.finishImpulseId != null;
	}
	get promoteFinishImpulseDisabled()
	{
		return this.args.selectedFinishImpulse == null || this.args.selectedFinishPlungerImpulse != null || this.args.selectedBibRecord != null || this.args.selectedFinishImpulse.finishPlungerImpulseId != null;
	}
	get clearEntryDisabled()
	{
		return this.args.selectedBibRecord != null || this.args.selectedFinishImpulse != null || this.args.selectedFinishPlungerImpulse == null || this.args.selectedFinishPlungerImpulse.EntryId == null;
	}
	get clearDisabled()
	{
		return this.args.selectedBibRecord == null && this.args.selectedFinishPlungerImpulse == null && this.args.selectedFinishImpulse == null;
	}
	get promoteEntryTimeDisabled()
	{
		return this.args.selectedBibRecord == null || this.args.selectedFinishPlungerImpulse != null || this.args.selectedFinishImpulse != null || this.args.selectedBibRecord.entryTime == null;
	}
	get associateBibDisabled()
	{
		return this.args.selectedFinishImpulse != null || this.args.selectedFinishPlungerImpulse == null || this.args.selectedBibRecord == null || this.args.selectedBibRecord.finishImpulseId != null || this.args.selectedBibRecord.finishPlungerImpulseId != null || this.args.selectedFinishPlungerImpulse.EntryId != null || this.args.selectedBibRecord.EntryId == null;
	}
	get disassociateBibDisabled()
	{
		return this.args.selectedBibRecord != null || this.args.selectedFinishImpulse != null || this.args.selectedFinishPlungerImpulse == null || this.args.selectedFinishPlungerImpulse.EntryId == undefined || (this.args.selectedFinishPlungerImpulse.finishImpulseId == null && this.args.selectedFinishPlungerImpulse.finishPlungerImpulseId == null);
	}
	get finishImpulseFunctionsDisabled()
	{
		return this.args.selectedFinishImpulse == null;
	}
	get finishPlungerImpulseFunctionsDisabled()
	{
		return this.args.selectedFinishPlungerImpulse == null;
	}
	get bibFunctionsDisabled()
	{
		return this.args.selectedBibRecord == null;
	}
	get dupFinishPlungerDisabled()
	{
		return this.args.selectedBibRecord != null || this.args.selectedFinishImpulse != null || this.args.selectedFinishPlungerImpulse == null || this.args.selectedFinishPlungerImpulse.finishPlungerImpulseId == null;
	}
	get dupFinishDisabled()
	{
		return this.args.selectedBibRecord != null || this.args.selectedFinishPlungerImpulse != null || this.args.selectedFinishImpulse == null || this.args.selectedFinishImpulse.finishImpulseId == null;
	}
	
	@action
	async associate()
	{	
		var sFI = this.args.selectedFinishImpulse;
		var sFPI = this.args.selectedFinishPlungerImpulse;
		
		if(sFPI == null)
		{
			alert("no finish plunger impulse selected");
			return;
		}
		if(sFI == null)
		{
			alert("no finish impulse selected");
			return;
		}
		if(sFPI.finishImpulseId != null)
		{
			alert("finish plunger imulse already has a finish impulse");
			return;
		}
		
		const response = await this.ajax.request("/finish-timing-records/"+sFPI.id+"/associateWithFinishImpulse/"+sFI.id)
		
		if(response.error != null)
			alert(response.error);
		
		this.args.finishImpulseSelectAction(null);
		this.args.finishPlungerImpulseSelectAction(null);
		this.args.bibRecordSelectedAction(null);
		this.enteredBib = null;
	}
	
	@action
	async disassociate()
	{
		var sFI = this.args.selectedFinishImpulse;
		var sFPI = this.args.selectedFinishPlungerImpulse;
		
		if(sFPI == null)
		{
			alert("no finish plunger impulse selected");
			return;
		}
		if(sFI != null)
		{
			alert("finish impulse must be cleared");
			return;
		}
		if(sFPI.finishImpulseId == null)
		{
			alert("finish plunger imulse has no time");
			return;
		}
		
		const response = await this.ajax.request("/finish-timing-records/"+sFPI.id+"/disassociateFinishImpulse");
		
		if(response.error != null)
			alert(response.error);
		
		this.args.finishImpulseSelectAction(null);
		this.args.finishPlungerImpulseSelectAction(null);
		this.args.bibRecordSelectedAction(null);
		this.enteredBib = null;
	}
	
	@action
	clear()
	{
		this.args.finishImpulseSelectAction(null);
		this.args.finishPlungerImpulseSelectAction(null);
		this.args.bibRecordSelectedAction(null);
		this.enteredBib = null;
	}
	
	@action
	async dupPlungerImpulse()
	{
		var sFI = this.args.selectedFinishImpulse;
		var sFPI = this.args.selectedFinishPlungerImpulse;
		
		if(sFI != null)
		{
			alert("finish impulse must be cleared");
			return;
		}
		if(sFPI == null)
		{
			alert("no finish plunger impulse selected");
			return;
		}
		
		const response = await this.ajax.request("/finish-timing-records/"+sFPI.id+"/dupFinishPlungerImpulse")
		
		if(response.error != null)
			alert(response.error);
		
		this.args.finishImpulseSelectAction(null);
		this.args.finishPlungerImpulseSelectAction(null);
		this.args.bibRecordSelectedAction(null);
		this.enteredBib = null;
	}
	
	@action
	async dupFinishImpulse()
	{
		var sFI = this.args.selectedFinishImpulse;
		var sFPI = this.args.selectedFinishPlungerImpulse;
		
		if(sFPI != null)
		{
			alert("finish plunger impulse must be cleared");
			return;
		}
		if(sFI == null)
		{
			alert("no finish impulse selected");
			return;
		}
		
		const response = await this.ajax.request("/finish-timing-records/"+sFI.id+"/dupFinishImpulse");
		
		if(response.error != null)
			alert(response.error);
		
		this.args.finishImpulseSelectAction(null);
		this.args.finishPlungerImpulseSelectAction(null);
		this.args.bibRecordSelectedAction(null);
		this.enteredBib = null;
	}
	
	@action
	async promoteFinishImpulse()
	{
		var sFI = this.args.selectedFinishImpulse;
		var sFPI = this.args.selectedFinishPlungerImpulse;
		
		if(sFPI != null)
		{
			alert("finish plunger impulse must be cleared");
			return;
		}
		if(sFI == null)
		{
			alert("no finish impulse selected");
			return;
		}
		
		if(sFI.finishPlungerImpulseId != null)
		{
			alert("finish impulse already has a finish plunger impulse");
			return;
		}
		
		const response = await this.ajax.request("/finish-timing-records/"+sFI.id+"/promoteFinishImpulse")
		
		if(response.error != null)
			alert(response.error);
		
		this.args.finishImpulseSelectAction(null);
		this.args.finishPlungerImpulseSelectAction(null);
		this.args.bibRecordSelectedAction(null);
		this.enteredBib = null;
	}
	
	@action
	async promoteFinishPlungerImpulse()
	{
		var sFI = this.args.selectedFinishImpulse;
		var sFPI = this.args.selectedFinishPlungerImpulse;
		
		if(sFI != null)
		{
			alert("finish impulse must be cleared");
			return;
		}
		if(sFPI == null)
		{
			alert("no finish plunger impulse selected");
			return;
		}
		
		if(sFPI.finishImpulseId != null)
		{
			alert("finish plunger impulse already has a finish impulse");
			return;
		}
		
		const response = await this.ajax.request("/finish-timing-records/"+sFPI.id+"/promoteFinishPlungerImpulse");
		
		if(response.error != null)
			alert(response.error);
		
		this.args.finishImpulseSelectAction(null);
		this.args.finishPlungerImpulseSelectAction(null);
		this.args.bibRecordSelectedAction(null);
		this.enteredBib = null;
	}
	
	@action
	async promoteEntryTime()
	{
		var sBR = this.args.selectedBibRecord;
		var sFI = this.args.selectedFinishImpulse;
		var sFPI = this.args.selectedFinishPlungerImpulse;
		
		if(sBR == null)
		{
			alert("no bib record selected");
			return;
		}
		
		if(sFI != null)
		{
			alert("finish impulse must be cleared");
			return;
		}
		if(sFPI != null)
		{
			alert("finish plunger impulse must be cleared");
			return;
		}
		
		if(sBR.finishImpulseId != null)
		{
			alert("bib record already has a finish impulse");
			return;
		}
		
		const response = await this.ajax.request("/finish-timing-records/"+sBR.id+"/promoteEntryTime");
		
		if(response.error != null)
			alert(response.error);
		
		this.args.finishImpulseSelectAction(null);
		this.args.finishPlungerImpulseSelectAction(null);
		this.args.bibRecordSelectedAction(null);
		this.enteredBib = null;
	}
	
	@action
	async clearEntry()
	{
		var sFI = this.args.selectedFinishImpulse;
		var sFPI = this.args.selectedFinishPlungerImpulse;
		var sBR = this.args.selectedBibRecord;
		
		if(sFI != null)
		{
			alert("finish impulse must be cleared");
			return;
		}
		if(sFPI == null)
		{
			alert("no finish plunger impulse selected");
			return;
		}
		
		if(sFPI.EntryId == null)
		{
			alert("finish plunger impulse has no entry");
			return;
		}
		
		const response = await this.ajax.request("/finish-timing-records/"+sFPI.id+"/clearEntry");
		
		if(response.error != null)
			alert(response.error);
		
		this.args.finishImpulseSelectAction(null);
		this.args.finishPlungerImpulseSelectAction(null);
		this.args.bibRecordSelectedAction(null);
		this.enteredBib = null;
	}
	
	@action
	async clearFinishAuto()
	{
		var sFI = this.args.selectedFinishImpulse;
		var sFPI = this.args.selectedFinishPlungerImpulse;
		
		if(sFI == null)
		{
			alert("no finish impulse selected");
			return;
		}
		
		const response = await this.ajax.request("/finish-timing-records/"+sFI.id+"/removeFromAutoAssociation");
		
		if(response.error != null)
			alert(response.error);
		
		this.args.finishImpulseSelectAction(null);
		this.args.finishPlungerImpulseSelectAction(null);
		this.args.bibRecordSelectedAction(null);
		this.enteredBib = null;
	}
	
	@action
	async setFinishAuto()
	{
		var sFI = this.args.selectedFinishImpulse;
		var sFPI = this.args.selectedFinishPlungerImpulse;
		
		if(sFI == null)
		{
			alert("no finish impulse selected");
			return;
		}
		
		const response = await this.ajax.request("/finish-timing-records/"+sFI.id+"/addToAutoAssociation");
		
		if(response.error != null)
			alert(response.error);
		
		this.args.finishImpulseSelectAction(null);
		this.args.finishPlungerImpulseSelectAction(null);
		this.args.bibRecordSelectedAction(null);
		this.enteredBib = null;
	}
	
	@action
	async clearPlungerAuto()
	{
		var sFI = this.args.selectedFinishImpulse;
		var sFPI = this.args.selectedFinishPlungerImpulse;
		
		if(sFPI == null)
		{
			alert("no finish plunger impulse selected");
			return;
		}
		
		const response = await this.ajax.request("/finish-timing-records/"+sFPI.id+"/removeFromAutoAssociation");
		
		if(response.error != null)
			alert(response.error);
		
		this.args.finishImpulseSelectAction(null);
		this.args.finishPlungerImpulseSelectAction(null);
		this.args.bibRecordSelectedAction(null);
		this.enteredBib = null;
	}
	
	@action
	async setPlungerAuto()
	{
		var sFI = this.args.selectedFinishImpulse;
		var sFPI = this.args.selectedFinishPlungerImpulse;
		
		if(sFPI == null)
		{
			alert("no finish plunger impulse selected");
			return;
		}
		
		const response = await this.ajax.request("/finish-timing-records/"+sFPI.id+"/addToAutoAssociation");
		
		if(response.error != null)
			alert(response.error);
		
		this.args.finishImpulseSelectAction(null);
		this.args.finishPlungerImpulseSelectAction(null);
		this.args.bibRecordSelectedAction(null);
		this.enteredBib = null;
	}
	
	@action
	async clearBibAuto()
	{
		var sBR = this.args.selectedBibRecord;
		
		if(sBR == null)
		{
			alert("no bib record selected");
			return;
		}
		
		const response = await this.ajax.request("/finish-timing-records/"+sBR.id+"/removeFromAutoAssociation");
		
		if(response.error != null)
			alert(response.error);
		
		this.args.finishImpulseSelectAction(null);
		this.args.finishPlungerImpulseSelectAction(null);
		this.args.bibRecordSelectedAction(null);
		this.enteredBib = null;
	}
	
	@action
	async setBibAuto()
	{
		var sBR = this.args.selectedBibRecord;
		
		if(sBR == null)
		{
			alert("no bib record selected");
			return;
		}
		
		const response = await this.ajax.request("/finish-timing-records/"+sBR.id+"/addToAutoAssociation");
		
		if(response.error != null)
			alert(response.error);
		
		this.args.finishImpulseSelectAction(null);
		this.args.finishPlungerImpulseSelectAction(null);
		this.args.bibRecordSelectedAction(null);
		this.enteredBib = null;
	}
	
	@action
	async clearBibPosted()
	{
		var sBR = this.args.selectedBibRecord;
		
		if(sBR == null)
		{
			alert("no bib record selected");
			return;
		}
		
		const response = await this.ajax.request("/finish-timing-records/"+sBR.id+"/clearPosted");
		
		if(response.error != null)
			alert(response.error);
		
		this.args.finishImpulseSelectAction(null);
		this.args.finishPlungerImpulseSelectAction(null);
		this.args.bibRecordSelectedAction(null);
		this.enteredBib = null;
	}
	
	@action
	async setBibPosted()
	{
		var sBR = this.args.selectedBibRecord;
		
		if(sBR == null)
		{
			alert("no bib record selected");
			return;
		}
		
		const response = await this.ajax.request("/finish-timing-records/"+sBR.id+"/setPosted");
		
		if(response.error != null)
			alert(response.error);
		
		this.args.finishImpulseSelectAction(null);
		this.args.finishPlungerImpulseSelectAction(null);
		this.args.bibRecordSelectedAction(null);
		this.enteredBib = null;
	}
	
	@action
	async bibEntered(value)
	{		
		var sFI = this.args.selectedFinishImpulse;
		var sFPI = this.args.selectedFinishPlungerImpulse;
		
		if(sFPI == null)
		{
			alert("no finish plunger impulse selected");
			return;
		}
		
		const response = await this.ajax.request("/finish-timing-records/"+sFPI.id+"/associateWithBib/"+this.enteredBib)
		
		if(response.error != null)
		{
			alert(response.error);
			return;
		}

		this.args.finishImpulseSelectAction(null);
		this.args.finishPlungerImpulseSelectAction(null);
		this.args.bibRecordSelectedAction(null);
		this.enteredBib = null;
	}
	
	@action
	async associateBibRecord()
	{
		var sFPI = this.args.selectedFinishPlungerImpulse;
		var sBR = this.args.selectedBibRecord;
		
		if(sFPI == null)
		{
			alert("no finish plunger impulse selected");
			return;
		}
		if(sBR == null)
		{
			alert("no bib record selected");
			return;
		}
		
		if(sBR.EntryId == null)
		{
			alert("invalid bib number");
			return;
		}
		if(sFPI.EntryId != null)
		{
			alert("finish plunger record already associated with an entry");
			return;
		}
		
		if(sBR.finishPlungerImpulseId != undefined)
		{
			alert("bib record already associated with a plunger impulse");
			return;
		}
		if(sBR.finishImpulseId != undefined)
		{
			alert("bib record already associated with a finish impulse");
			return;
		}
		
		const response = await this.ajax.request("/finish-timing-records/"+sFPI.id+"/associateWithBibRecord/"+sBR.id);
		
		if(response.error != null)
		{
			alert(response.error);
			return;
		}
			
		this.args.finishImpulseSelectAction(null);
		this.args.finishPlungerImpulseSelectAction(null);
		this.args.bibRecordSelectedAction(null);
		this.enteredBib = null;

	}
	
	@action
	async disassociateBibRecord()
	{
		var sFPI = this.args.selectedFinishPlungerImpulse;
		var sBR = this.args.selectedBibRecord;
		
		if(sFPI == null)
		{
			alert("no finish plunger impulse record selected");
			return;
		}
		if(sBR != null)
		{
			alert("bib record must be cleared");
			return;
		}
		
		if(sFPI.EntryId == null)
		{
			alert("finish plunger impulse record has no bib associated");
			return;
		}
		
		const response = await this.ajax.request("/finish-timing-records/"+sFPI.id+"/disassociateBibRecord")
		
		if(response.error != null)
		{
			alert(response.error);
			return;
		}
			
		this.args.finishImpulseSelectAction(null);
		this.args.finishPlungerImpulseSelectAction(null);
		this.args.bibRecordSelectedAction(null);
		this.enteredBib = null;

	}
}
